import { Link } from 'react-router-dom';

const services = [
  'Webサイト制作・運営',
  'Webアプリケーション開発',
  '情報システムの企画・開発・運用',
  'ネットワーク構築・保守',
  'ITコンサルティング',
  'システム保守・監視サービス',
];

const companyLinks = [
  { label: 'ホーム', href: '/#home' },
  { label: 'サービス紹介', href: '/#services' },
  { label: 'お問い合わせ', href: '/#contact' },
  { label: 'プライバシーポリシー', href: '/privacy-policy' },
];

export default function Footer() {
  const handleNavClick = (href: string) => {
    if (href.startsWith('/#')) {
      const id = href.replace('/#', '');
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gray-50 border-t-4 border-yellow-400 relative overflow-hidden">
      {/* Decorative gear */}
      <div className="absolute right-8 top-8 opacity-5 pointer-events-none select-none">
        <i className="ri-settings-3-line text-[200px] text-gray-800"></i>
      </div>
      <div className="absolute left-4 bottom-4 opacity-5 pointer-events-none select-none">
        <i className="ri-tools-line text-[120px] text-gray-800"></i>
      </div>

      <div className="max-w-7xl mx-auto px-4 md:px-8 py-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 relative z-10">
        {/* Brand */}
        <div>
          <img
            src="https://public.readdy.ai/ai/img_res/5efa179f-c5aa-4dc7-9a31-2f4acddd08fc.png"
            alt="合同会社アテディア"
            className="h-10 w-auto object-contain mb-4"
          />
          <p className="text-sm text-gray-500 leading-relaxed mb-4">
            大阪発のITソリューション企業。<br />
            技術力と誠実さで、お客様のビジネスを加速させます。
          </p>
          <div className="flex items-start gap-2 text-sm text-gray-500">
            <div className="w-4 h-4 flex items-center justify-center mt-0.5">
              <i className="ri-map-pin-line text-yellow-500"></i>
            </div>
            <span>大阪府大阪市東成区深江北一丁目6-31-601</span>
          </div>
          <div className="flex items-center gap-2 text-sm text-gray-500 mt-2">
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-calendar-line text-yellow-500"></i>
            </div>
            <span>設立：令和4年9月5日</span>
          </div>
        </div>

        {/* Services */}
        <div>
          <h4 className="text-xs font-bold tracking-widest text-gray-800 mb-4 uppercase">Services</h4>
          <ul className="flex flex-col gap-3">
            {services.map((s) => (
              <li key={s}>
                <button
                  onClick={() => handleNavClick('/#services')}
                  className="text-sm text-gray-500 hover:text-yellow-500 transition-colors duration-200 cursor-pointer text-left"
                >
                  {s}
                </button>
              </li>
            ))}
          </ul>
        </div>

        {/* Company */}
        <div>
          <h4 className="text-xs font-bold tracking-widest text-gray-800 mb-4 uppercase">Company</h4>
          <ul className="flex flex-col gap-3">
            {companyLinks.map((link) => (
              <li key={link.label}>
                {link.href.startsWith('/#') ? (
                  <button
                    onClick={() => handleNavClick(link.href)}
                    className="text-sm text-gray-500 hover:text-yellow-500 transition-colors duration-200 cursor-pointer text-left"
                  >
                    {link.label}
                  </button>
                ) : (
                  <Link
                    to={link.href}
                    className="text-sm text-gray-500 hover:text-yellow-500 transition-colors duration-200"
                  >
                    {link.label}
                  </Link>
                )}
              </li>
            ))}
          </ul>
        </div>

        {/* Contact */}
        <div>
          <h4 className="text-xs font-bold tracking-widest text-gray-800 mb-4 uppercase">Contact</h4>
          <a
            href="mailto:info@atedia.co.jp"
            className="flex items-center gap-2 text-sm text-gray-500 hover:text-yellow-500 transition-colors duration-200 mb-6"
          >
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-mail-line"></i>
            </div>
            info@atedia.co.jp
          </a>

        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-gray-200">
        <div className="max-w-7xl mx-auto px-4 md:px-8 py-4 flex flex-col sm:flex-row items-center justify-between gap-2">
          <p className="text-xs text-gray-400">© 2024 合同会社アテディア. All rights reserved.</p>
          <div className="flex gap-4">
            <Link to="/privacy-policy" className="text-xs text-gray-400 hover:text-yellow-500 transition-colors duration-200">
              プライバシーポリシー
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
